<template lang="html">
  <div class="home" ref="communication" >
    <!-- <h3>星圈</h3> -->
    <Header />
    <div class="body">
      <router-view/>
      <div class="body2">
        <Passageway selfStyle="padding-right: 0;"/>
        <ReturnList selfStyle="padding-right: 0;"/>
        <HeatedDiscussion selfStyle="padding-right: 0;"/>
        <Links selfStyle="padding-right: 0;"/>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Passageway from '../../../components/Passageway.vue'
import ReturnList from '../../../components/ReturnList.vue'
import HeatedDiscussion from '../../../components/HeatedDiscussion.vue'
import Header from '../../../components/Header.vue'
import Links from '../../../components/Links.vue'
// import { Component, Vue } from 'vue-property-decorator'
// import { Action } from 'vuex-class'
import { createNamespacedHelpers } from 'vuex'
import { isAndroid } from '../../../utils/utils'
const { mapActions } = createNamespacedHelpers('refresh')
const { mapTabBarActions } = createNamespacedHelpers('tabbar')
export default {
  components: {
    Header,
    Passageway,
    ReturnList,
    HeatedDiscussion,
    Links
  },
  data () {
    return {
      loading: false,
      touchStart: 0,
      distance: 0,
      isAndroid: isAndroid(),
      safeHeight: 0
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.$store.dispatch('tabbar/updateTabIndex', 'bbs')
    })
  },
  mounted () {
    const body = this.$refs.communication
    body.addEventListener('touchstart', (e) => {
      if (this.loading) {
        e.preventDefault()
        return
      }
      this.touchStart = e.targetTouches[0].clientY
    })
    body.addEventListener('touchmove', (e) => {
      if (body.scrollTop === 0) {
        const touch = e.targetTouches[0]
        const distance = touch.clientY - this.touchStart
        if (this.loading) {
          return
        }
        if (distance > 80) {
          this.loading = true
          e.preventDefault()
          this.$store.dispatch('refresh/updateDownRefresh', true)
        }
      }
    })
    body.addEventListener('touchend', (e) => {
      this.loading = false
      this.$store.dispatch('refresh/updateDownRefresh', false)
      this.touchStart = 0
      this.distance = 0
      if (this.distance === 0) {
        return
      }
      if (this.loading) {
        e.preventDefault()
      }
    })
  },
  methods: {
    ...mapActions({
      updateDownRefresh: 'updateDownRefresh'
    }),
    ...mapTabBarActions({
      updateTabIndex: 'updateTabIndex'
    })

  }
}
</script>

<style lang="scss" scoped>
.home {
  box-sizing: border-box;
  overflow-y: scroll;
  max-width: 100vw;
  background-color: #f0f0f0;
  height: calc(100% - 50px);
  h3 {
    text-align: center;
    padding: 9px;
    font-size:17px;
    font-family:SFProText-Semibold,SFProText;
    font-weight: bold;
    color:rgba(0,0,0,1);
    line-height:22px;
    border-bottom: 1px solid #E2E2E2;
    background: #fff;
  }
}
  .body {
    display: flex;
    max-width: 1160px;
    margin-left: auto;
    margin-right: auto;
  }
  .body1 {
    width: 66.666666%;
  }
  .body2 {
    width: 33.33333333%;
  }
  @media screen and (max-width: 768px) {
    .body {
      flex-direction: column;
      justify-content: center;
      .body1, .body2 {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 768px) {
    .body {
      width: 750px;
    }
  }
  @media screen and (min-width: 992px) {
    .body {
      width: 970px;
    }
  }
  @media screen and (min-width: 1200px) {
    .body {
      width: 1170px;
    }
  }
</style>
